import { makeAddress } from './address';
import { general } from './general';

const defaultAlternateAddress = (options = {}) => ({
  Address: {},
  HasDifferentAddress: { value: '' },
  Telephone: {},
  ...(options || {}),
});

const emptyState = (options = {}) => ({
  Address: {
    country: null,
  },
  HasDifferentAddress: { value: '' },
  Telephone: {},
  ...(options || {}),
});

const alternateaddress = (data = {}) => general('alternateaddress', emptyState(data));

/** Used for for unit testing. */
const makeAlternateAddress = (options = {}) => ({
  Address: makeAddress(),
  HasDifferentAddress: { value: '' },
  Telephone: {},
  ...(options || {}),
});

export {
  alternateaddress,
  defaultAlternateAddress,
  makeAlternateAddress,
};
export default emptyState;
